import Login from './Login';
import Registrasi from './Registrasi';
import {authRoles} from 'auth';
import RegistrasiDapodik from './RegistrasiDapodik';

export const LoginConfig = {
    settings: {
        layout: {
            config: {
                navbar        : {
                    display: false
                },
                toolbar       : {
                    display: false
                },
                footer        : {
                    display: false
                },
                leftSidePanel : {
                    display: false
                },
                rightSidePanel: {
                    display: false
                }
            }
        }
    },
    auth    : authRoles.onlyGuest,
    routes  : [
        {
            path     : '/login',
            component: Login
        },
        {
            path     : '/registrasi',
            component: Registrasi
        },
        {
            path     : '/registrasiDapodik',
            component: RegistrasiDapodik
        }
    ]
};




// WEBPACK FOOTER //
// ./src/main/content/login/LoginConfig.js